import { useEffect, useMemo, useRef, useState } from "react";
import { iVendaAPI } from "../../../../servicos/intencaovenda";
import ListagemFeedback from "../../../Listagem/feedback";
import ListagemOpcoes from "../../../Listagem/opcoes";
import Topo from "../../../Topo/topo";
import Paginacao from "../../../Listagem/paginacao";
import { formatarMoedaBRL, normalizarValorNumerico } from "../../../../constantes/relatorios";
import { exportarXLSX } from "../../../../utilitarios/excel";

function TabelaRelatorioIntencaoVenda() {

    const date = new Date();

    const breadcrumbs = ['Home','Relatório Intenção de Venda'];
    const [PesquisaRelatorioIntencaoVenda, setPesquisaRelatorioIntencaoVenda] = useState([]);
    const [totalTaxa, setTotalTaxa] = useState(0);
    const [totalValor, setTotalValor] = useState(0);
    
    const [exibeErro, setExibeErro] = useState(false);    
    const [mensagemErro, setMensagemErro] = useState('');    

    const [mes, setmes] = useState(date.getMonth()+1);
    const [ano, setano] = useState(String(date.getFullYear()));
    const [anosDisponiveis, setAnosDisponiveis] = useState([]);

    const tableRef = useRef(null);

    const baseInputClass = 'form-input tw-h-11 tw-rounded-xl tw-border tw-border-transparent tw-bg-slate-50 tw-px-4 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-inner tw-transition-all placeholder:tw-text-slate-400 hover:tw-border-indigo-300 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-indigo-400 focus-visible:tw-border-indigo-500 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 dark:tw-border-slate-700 dark:tw-bg-slate-800 dark:tw-text-slate-100 dark:placeholder:tw-text-slate-500 dark:hover:tw-border-indigo-400/40 dark:focus-visible:tw-ring-indigo-300/60';

    useEffect(() => {
        fetchIntencaoVenda(mes, ano);
    }, [mes, ano]);

    useEffect(() => {
        fetchAnosIntencaoVenda();
    }, []);

    useEffect(() => {
        const anoAtual = String(ano);
        if (anosDisponiveis.length > 0 && !anosDisponiveis.includes(anoAtual)) {
            setano(anosDisponiveis[anosDisponiveis.length - 1]);
        }
    }, [anosDisponiveis, ano]);

    async function fetchIntencaoVenda(fMes,fAno){

        iVendaAPI.get(`/relatorio/${fMes}/${fAno}`)
        .then(resposta => {
            setPesquisaRelatorioIntencaoVenda(resposta.data);
            const taxaTotal = resposta.data.reduce((acc, item) => {
                const bruto = item?.fi100_vlr_intencao_venda ?? item?.fi100_filiado?.fi100_vlr_intencao_venda ?? 0;
                return acc + normalizarValorNumerico(bruto);
            }, 0);
            setTotalTaxa(taxaTotal);
            const valorTotal = resposta.data.reduce(
                (acc, item) => acc + normalizarValorNumerico(item.ve103_vlr_venda),
                0,
            );
            setTotalValor(valorTotal);
        })
        .catch(erro => {          
            setTotalTaxa(0);
            setTotalValor(0);
            if(erro?.resposta?.data?.message){
                setExibeErro(true);
                setMensagemErro(erro.resposta.data.message);
            }else{
                if (erro.response?.status === 401) {
                    setExibeErro(true);
                    setMensagemErro('Ops! Sessão Expirada! Faça um novo login.');
                  }else{
                    setExibeErro(true);
                    setMensagemErro('Ops! Ocorreu um erro inesperado.');
                  }                                           
            }        
        })               
        
    }        

    async function fetchAnosIntencaoVenda(){
        iVendaAPI.get('/relatorio/anos')
        .then(resposta => {
            const anos = (resposta.data?.anos || []).map((item) => String(item));
            setAnosDisponiveis(anos);
        })
        .catch(erro => {
            setAnosDisponiveis([]);
            if(erro?.resposta?.data?.message){
                setExibeErro(true);
                setMensagemErro(erro.resposta.data.message);
            }else{
                if (erro.response?.status === 401) {
                    setExibeErro(true);
                    setMensagemErro('Ops! Sess\u00E3o Expirada! Fa\u00E7a um novo login.');
                  }else{
                    setExibeErro(true);
                    setMensagemErro('Ops! Ocorreu um erro inesperado.');
                  }
            }
        })
    }        

    function FormatarDataHora(string){

        var retorno = '';
        if(string !== null){
            string = string.split("T");        
            var dataaux = string[0].split("-");
            var dataformatada = dataaux[2] + '/' + dataaux[1] + "/" + dataaux[0];      
            retorno = dataformatada + ' ' + string[1].substring(0,5) ;    
        }

        return retorno;

    }

    const cabecalhoExportacao = useMemo(
        () => [
            'Placa',
            'CNPJ',
            'Renavam',
            'CRV',
            'Documento Comprador',
            'Comprador',
            'Valor',
            'Taxa por Intenção',
            'ATPVe',
            'Data Cadastro',
            'Situação',
            'Data Situação',
        ],
        [],
    );

    const handleExportarExcel = () => {
        const linhas = PesquisaRelatorioIntencaoVenda.map((ivenda) => [
            ivenda.ve103_dsc_placa || '',
            ivenda.fi100_num_cnpj || ivenda.fi100_filiado?.fi100_num_cnpj || '',
            ivenda.ve103_num_renavam || '',
            ivenda.ve103_num_crv || '',
            ivenda.ve103_num_documento_comprador || '',
            ivenda.ve103_dsc_nome_comprador || '',
            normalizarValorNumerico(ivenda.ve103_vlr_venda),
            normalizarValorNumerico(ivenda?.fi100_vlr_intencao_venda ?? ivenda?.fi100_filiado?.fi100_vlr_intencao_venda ?? 0),
            ivenda.ve103_num_atpve || '',
            FormatarDataHora(ivenda.createdAt) || '',
            ivenda.ve103_dsc_situacao || '',
            FormatarDataHora(ivenda.ve103_dat_situacao) || '',
        ]);

        linhas.push([
            'Totais',
            '',
            '',
            '',
            '',
            '',
            normalizarValorNumerico(totalValor),
            normalizarValorNumerico(totalTaxa),
            '',
            '',
            '',
            '',
        ]);

        exportarXLSX({
            arquivo: 'ConexaoDetranPR_IntencaoVenda',
            aba: 'Intenção de Venda',
            cabecalho: cabecalhoExportacao,
            linhas,
            colunasNumericas: [6, 7],
        });
    };

    return (
        <div class="row">
            <div class="container">
                <Topo titulo='Relatório Intenção de Venda' breadcrumbs={breadcrumbs} btnincluir={false} admin={true}/>
                <ListagemFeedback
                    displayErro={exibeErro}
                    mensagemErro={mensagemErro}
                    displaySucesso={false}
                    mensagemSucesso={''}
                />
                <ListagemOpcoes
                    esconderTamanhoPagina={true}
                    esconderOpcaoFiltro={true}
                    esconderCampoFiltro={true}
                /> 
            </div>
            <div class="row row-padding-conteudo tw-items-end tw-gap-4" style={{marginBottom: '10px'}}>
                <div class="col-12">
                    <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-4 tw-gap-y-3">
                        <div class="tw-flex tw-items-center tw-gap-3">
                            <label for="mes" class="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600 dark:tw-text-white tw-leading-none">
                                Mês:
                            </label>
                            <select className={`${baseInputClass} tw-w-auto tw-min-w-[160px] dark:tw-text-white`} aria-label="Selecione" id="mes" name="mes" onChange={evento => {setmes(evento.target.value);fetchIntencaoVenda(evento.target.value,ano);}} value={mes} >
                                <option value="1">Janeiro</option>
                                <option value="2">Fevereiro</option>
                                <option value="3">Março</option>
                                <option value="4">Abril</option>
                                <option value="5">Maio</option>
                                <option value="6">Junho</option>
                                <option value="7">Julho</option>
                                <option value="8">Agosto</option>
                                <option value="9">Setembro</option>
                                <option value="10">Outubro</option>
                                <option value="11">Novembro</option>
                                <option value="12">Dezembro</option>
                            </select>
                        </div>
                        <div class="tw-flex tw-items-center tw-gap-3">
                            <label for="ano" class="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600 dark:tw-text-white tw-leading-none">
                                Ano:
                            </label>
                            <select className={`${baseInputClass} tw-w-auto tw-min-w-[120px] dark:tw-text-white`} aria-label="Selecione" id="ano" name="ano" onChange={evento => {setano(evento.target.value);fetchIntencaoVenda(mes,evento.target.value);}} value={ano} >
                                {anosDisponiveis.map((item) => (
                                    <option key={item} value={item}>{item}</option>
                                ))}
                            </select>
                        </div>
                        <div class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-font-semibold tw-text-slate-600 dark:tw-text-white">
                            <span>Valor Total:</span>
                            <span class="tw-text-base tw-font-semibold tw-text-slate-900 dark:tw-text-white">{formatarMoedaBRL(totalValor)}</span>
                        </div>
                        <div class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-font-semibold tw-text-slate-600 dark:tw-text-white">
                            <span>Taxa Total:</span>
                            <span class="tw-text-base tw-font-semibold tw-text-slate-900 dark:tw-text-white">{formatarMoedaBRL(totalTaxa)}</span>
                        </div>
                        <div class="tw-flex tw-items-center tw-justify-end tw-gap-2 tw-ml-auto">
                            <button type="button" class="btn-export-excel" onClick={handleExportarExcel}>
                                <span class="material-symbols-outlined">cloud_download</span>
                                <span>Exportar Excel</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        <div class="row row-padding-conteudo">
            <div class="col-12 mobile-hide tablet-hide">
                <div class="table-responvive">
                    <table class="table" ref={tableRef}>
                        <thead>
                            <tr>
                                <th class="topo" scope="col">Placa</th>
                                <th class="topo" scope="col">CNPJ</th>
                                <th class="topo" scope="col">Renavam</th>
                                <th class="topo" scope="col">CRV</th>
                                <th class="topo" scope="col">Documento Comprador</th>
                                <th class="topo" scope="col">Comprador</th>
                                <th class="topo" scope="col">Valor</th>
                                <th class="topo" scope="col">Taxa por Intenção</th>
                                <th class="topo" scope="col">ATPVe</th>
                                <th class="topo" scope="col">Data Cadastro</th>
                                <th class="topo" scope="col">Situação</th>
                                <th class="topo" scope="col">Data Situação</th>
                            </tr>
                        </thead>
                        <tbody>
                            {PesquisaRelatorioIntencaoVenda.map((ivenda, indice) => (
                                <tr key={ivenda.ve103_key_public || indice}>
                                    <td>
                                        {ivenda.ve103_dsc_placa}
                                    </td>
                                    <td>
                                        {ivenda.fi100_num_cnpj || ivenda.fi100_filiado?.fi100_num_cnpj || '-'}
                                    </td>
                                    <td>
                                        {ivenda.ve103_num_renavam}
                                    </td>
                                    <td>
                                        {ivenda.ve103_num_crv}
                                    </td>
                                    <td>
                                        {ivenda.ve103_num_documento_comprador}
                                    </td>
                                    <td>
                                        {ivenda.ve103_dsc_nome_comprador}
                                    </td>
                                    <td>
                                        {formatarMoedaBRL(normalizarValorNumerico(ivenda.ve103_vlr_venda))}
                                    </td>
                                    <td>
                                        {formatarMoedaBRL(
                                            normalizarValorNumerico(ivenda?.fi100_vlr_intencao_venda ?? ivenda?.fi100_filiado?.fi100_vlr_intencao_venda ?? 0)
                                        )}
                                    </td>
                                    <td>
                                        {ivenda.ve103_num_atpve}
                                    </td>
                                    <td>
                                        {FormatarDataHora(ivenda.createdAt)}
                                    </td>
                                    <td>
                                        {ivenda.ve103_dsc_situacao}
                                    </td>
                                    <td>
                                        {FormatarDataHora(ivenda.ve103_dat_situacao)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    <Paginacao esconder={true} />
</div>
);

}

export default TabelaRelatorioIntencaoVenda;

